import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import SearchResultCard, { SearchResultType } from '@/components/Search/SearchResultCard.jsx';

import { usePatientAppointments } from '@/hooks/use-patient-appointments.js';

import { sectionHeading } from '@/styles/sectionHeading.ts';

import { useSearchStore } from '@/store.js';

const LIMIT = 4;

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
    },
    heading: sectionHeading(theme),
    cards: {
        // Two across rather than one track per possible card, which tied the column count to LIMIT.
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        alignItems: 'stretch',
        gap: '1rem',
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
        },
    },
}));

const PreviousDoctors = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { past } = usePatientAppointments();
    const professionals = useSearchStore((state) => state.professionals);

    const seenBefore = [];
    past.forEach((appointment) => {
        const key = appointment.professional?.key;
        if (!key || seenBefore.some((entry) => entry.key === key)) return;
        const professional = professionals?.[key];
        if (professional?.display_name?.[0]?.text) seenBefore.push({ key: key, professional: professional });
    });

    const visible = seenBefore.slice(0, LIMIT);

    if (visible.length === 0) return null;

    return (
        <div className={classes.wrapper}>
            <Typography className={classes.heading}>{t('PreviousDoctorsHeading')}</Typography>
            <div className={classes.cards}>
                {visible.map(({ key, professional }) => (
                    <SearchResultCard
                        key={key}
                        cardKey={key}
                        prismicData={professional}
                        searchResultType={SearchResultType.PROFESSIONAL}
                    />
                ))}
            </div>
        </div>
    );
};

export default PreviousDoctors;
